module.exports = __webpack_public_path__ + "img/glamping_3.6884c9a5.jpg";